import React from 'react';
import PropTypes from 'prop-types';
import styles from './HelpModal.module.css';

// Shared page-explainer modal (see the meet points and age results pages).
// Closes only via the header X or the Close button, never on overlay click.
// The rounded box clips and the box inside it scrolls, so a long text's
// scrollbar is cut to the round corners instead of squaring them (the points
// help grew long enough to scroll in the points work; Doug, 2026-10-26, S3).
const HelpModal = ({ open, title, onClose, children }) => {
  if (!open) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalScroll}>
          <div className={styles.modalHeader}>
            <h2 className={styles.modalTitle}>{title}</h2>
            <button
              className={styles.closeBtn}
              onClick={onClose}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <div className={styles.modalBody}>{children}</div>
          <div className={styles.modalFooter}>
            <button className={styles.closeButton} onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

HelpModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
};

export default HelpModal;
